import { Score, ScoreCnb } from "@prisma/client";

export interface IScores {
  formatted: Score;
  cnb: ScoreCnb;
  skills: Skills;
}

export interface SkillsBasic {
  verbalReasoning: SkillBasic;
  abstractReasoning: SkillBasic;
  spatialPerception: SkillBasic;
  verbalMemory: SkillBasic;
  visualMemory: SkillBasic;
  attention: SkillBasic;
  flexibleThinking: SkillBasic;
  workingMemory: SkillBasic;
  processingSpeed: SkillBasic;
  visualMotorSpeed: SkillBasic;
}

export interface Skills {
  verbalReasoning: Skill;
  abstractReasoning: Skill;
  spatialPerception: Skill;
  verbalMemory: Skill;
  visualMemory: Skill;
  attention: Skill;
  flexibleThinking: Skill;
  workingMemory: Skill;
  processingSpeed: Skill;
  visualMotorSpeed: Skill;
}

export interface Skill {
  label: string;
  category: SkillCategory;
  overall: IScore;
  accuracy: IScore;
  efficiency: IScore;
  speed: IScore;
  valid: boolean | null;
}

export interface SkillBasic {
  label: string;
  category: SkillCategory;
  range: ScoreRangeValues;
  zScore: number;
}

export enum SkillCategory {
  complexReasoning = "complexReasoning",
  memory = "memory",
  executiveFunctions = "executiveFunctions",
  speed = "speed",
}

export interface IScore {
  zScore: number;
  percentile: number | null;
  range: ScoreRangeValues;
}

export enum ScoreRangeValues {
  HighStrength = "HIGH_STRENGTH",
  MediumStrength = "MEDIUM_STRENGTH",
  HighExpected = "HIGH_EXPECTED",
  MediumExpected = "MEDIUM_EXPECTED",
  LowExpected = "LOW_EXPECTED",
  MediumWeakness = "MEDIUM_WEAKNESS",
  LowWeakness = "LOW_WEAKNESS",
  Invalid = "INVALID",
}

export interface ScoreRanges {
  abstractReasoningScoreRange: ScoreRangeValues;
  attentionScoreRange: ScoreRangeValues;
  attentionSpeedScoreRange: ScoreRangeValues;
  flexibleThinkingScoreRange: ScoreRangeValues;
  processingSpeedScoreRange: ScoreRangeValues;
  spatialPerceptionScoreRange: ScoreRangeValues;
  verbalMemoryScoreRange: ScoreRangeValues;
  verbalMemorySpeedScoreRange: ScoreRangeValues;
  verbalReasoningScoreRange: ScoreRangeValues;
  verbalReasoningSpeedScoreRange: ScoreRangeValues;
  visualMemoryScoreRange: ScoreRangeValues;
  visualMemorySpeedScoreRange: ScoreRangeValues;
  visualMotorSpeedScoreRange: ScoreRangeValues;
  workingMemoryScoreRange: ScoreRangeValues;
}
